import $ from 'jquery';

export async function initSingleRealty(singleRealty) {
    const layouts = new Map(),
        exposeBooster = singleRealty.querySelector('[data-expose-booster]');

    let activeLayout;

    singleRealty.querySelectorAll('[data-layout]').forEach((layout) => {
        const slots = new Map();

        layout.querySelectorAll('[data-slot]').forEach((slot) => {
            slots.set(slot.dataset.slot, slot);
        });

        layouts.set(layout.dataset.layout, { slots, layout });

        if ('initial' in layout.dataset) {
            activeLayout = { slots, layout };
        }
    });

    // eslint-disable-next-line jquery/no-trigger
    $(window)
        .on('changed.zf.mediaquery', () => {
            const intendedLayout = Array.from(layouts.entries())
                .reverse()
                .find(([breakpoint]) => Foundation.MediaQuery.atLeast(breakpoint));

            if (intendedLayout) {
                const { layout, slots } = layouts.get(intendedLayout[0]);

                if (layout.hidden === true) {
                    activeLayout.layout.hidden = true;

                    for (const [slot, element] of activeLayout.slots.entries()) {
                        slots.get(slot).append.apply(slots.get(slot), element.childNodes);
                    }

                    activeLayout = { slots, layout };
                    layout.hidden = false;
                }
            }
        })
        .trigger('changed.zf.mediaquery');

    if (exposeBooster) {
        window.addEventListener('message', (event) => {
            if (event.origin !== 'https://webservice02.checkmyplace.com') {
                return;
            }

            try {
                const message = JSON.parse(event.data);

                if (message.height && !isNaN(message.height)) {
                    exposeBooster.style.height = message.height + 'px';
                }
            } catch (e) {
                // discard
            }
        });

        exposeBooster.addEventListener('load', () => {
            const intersectionObserver = new IntersectionObserver((entries, observer) => {
                observer.disconnect();

                entries.forEach(({ target }) => {
                    target.contentWindow.postMessage(
                        { 'lageinfo-open': true },
                        'https://webservice02.checkmyplace.com',
                    );
                });
            });

            intersectionObserver.observe(exposeBooster);
        });
    }
}
